{
  "common": {
    "cancel": "Annuler",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "done": "Terminé",
    "edit": "Modifier",
    "search": "Rechercher",
    "loading": "Chargement…",
    "yes": "Oui",
    "no": "Non",
    "settings": "Paramètres",
    "back": "Retour",
    "close": "Fermer",
    "open": "Ouvrir",
    "copy": "Copier",
    "restore": "Restaurer",
    "untitled": "Sans titre",
    "create": "Créer",
    "revoke": "Révoquer",
    "never": "Jamais",
    "tryAgain": "Réessayer",
    "reload": "Recharger",
    "update": "Mettre à jour",
    "insert": "Insérer",
    "loadingShort": "Chargement",
    "unknown": "Inconnu",
    "sampleSentence": "Le vif renard brun"
  },
  "sidebar": {
    "views": "Vues",
    "tags": "Étiquettes",
    "edit": "Modifier",
    "done": "Terminé",
    "account": "Compte",
    "newNote": "Nouvelle note",
    "editTag": "Modifier l'étiquette",
    "tagOptions": "Options de l'étiquette",
    "reorder": "Réordonner {{label}}",
    "showView": "Afficher {{label}}",
    "hideView": "Masquer {{label}}",
    "editViews": "Modifier les vues",
    "doneEditingViews": "Terminer la modification",
    "samplePeep": "Caliu, c'est…",
    "sampleQuiet": "Un endroit calme où vos idées peuvent vivre et respirer."
  },
  "views": {
    "all": "Toutes les notes",
    "today": "Aujourd'hui",
    "todo": "Tâches",
    "pinned": "Épinglées",
    "untagged": "Sans étiquette",
    "thisWeek": "Cette semaine",
    "shared": "Partagées par moi",
    "sharedWithMe": "Partagées avec moi",
    "attachments": "Pièces jointes",
    "trash": "Corbeille",
    "archive": "Archivées"
  },
  "noteList": {
    "empty": "Pas encore de notes",
    "emptySubtitle": "Créez votre première note pour commencer.",
    "untitled": "Sans titre",
    "selectNote": "Sélectionnez une note",
    "selectNoteHint": "Choisissez une note dans la liste, ou créez-en une nouvelle.",
    "selectRestoreOrDelete": "Sélectionnez une note pour la restaurer ou la supprimer définitivement",
    "selectSharedToView": "Sélectionnez une note partagée pour la voir",
    "searchPlaceholder": "Rechercher des notes…",
    "selectNotes": "Sélectionner des notes",
    "openSidebar": "Ouvrir la barre latérale",
    "cancelSelection": "Annuler la sélection",
    "clearSelection": "Effacer la sélection",
    "emptyTrash": "Vider la corbeille",
    "newNote": "Nouvelle note",
    "noteCount_one": "{{count}} note",
    "noteCount_other": "{{count}} notes",
    "sortBy": "Trier par",
    "preview": "Aperçu",
    "modificationDate": "Date de modification",
    "creationDate": "Date de création",
    "title": "Titre",
    "manual": "Manuel",
    "newestOnTop": "Plus récentes en haut",
    "small": "Petite",
    "medium": "Moyenne",
    "large": "Grande",
    "empty_pinned": "Rien d'épinglé pour l'instant",
    "empty_pinned_subtitle": "Épinglez une note pour la retrouver rapidement ici.",
    "empty_today": "Rien d'édité aujourd'hui",
    "empty_today_subtitle": "Les notes que vous modifiez aujourd'hui apparaîtront ici.",
    "empty_todo": "Pas encore de tâches",
    "empty_todo_subtitle": "Les notes avec des tâches ouvertes apparaîtront ici.",
    "empty_untagged": "Tout est étiqueté",
    "empty_untagged_subtitle": "Les notes sans étiquettes apparaîtront ici.",
    "empty_thisWeek": "Rien cette semaine",
    "empty_thisWeek_subtitle": "Les notes modifiées ces 7 derniers jours apparaîtront ici.",
    "empty_shared": "Aucune note partagée",
    "empty_shared_subtitle": "Les notes que vous partagez apparaîtront ici.",
    "empty_attachments": "Pas encore de pièces jointes",
    "empty_attachments_subtitle": "Les notes avec des images ou fichiers apparaîtront ici.",
    "justNow": "À l'instant",
    "minutesAgo": "il y a {{count}} min",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "deletedOn": "Supprimée le {{date}}",
    "newNoteShortcut": "Nouvelle note ({{shortcut}})",
    "noContent": "Aucun contenu",
    "selectUnarchiveOrDelete": "Sélectionnez une note pour la désarchiver ou la supprimer",
    "view": "Affichage",
    "density": "Densité",
    "exportAll": "Tout exporter"
  },
  "editor": {
    "attachmentTooLarge": "Ce fichier est trop volumineux pour être joint. La limite est de 100 Mo.",
    "placeholder": "Commencez à écrire…",
    "noMatchingCommands": "Aucune commande correspondante",
    "newNote": "nouvelle note",
    "noResults": "Aucun résultat",
    "foldSection": "Replier la section",
    "unfoldSection": "Déplier la section",
    "dragSection": "Déplacer la section",
    "presenceLabel": "Également ici : {{names}}"
  },
  "noteActions": {
    "pin": "Épingler",
    "unpin": "Désépingler",
    "pinToTop": "Épingler en haut",
    "makeReadOnly": "Passer en lecture seule",
    "makeEditable": "Rendre modifiable",
    "readOnlyNote": "Note en lecture seule",
    "shareNote": "Partager la note",
    "share": "Partager",
    "publiclyShared": "Partagée publiquement",
    "privateNote": "Note privée",
    "linkCreated": "Lien créé",
    "linkCreatedAndCopied": "Lien créé et copié",
    "linkRevoked": "Lien de partage révoqué",
    "failedToCreateShareLink": "Impossible de créer le lien de partage",
    "failedToRevokeShareLink": "Impossible de révoquer le lien de partage",
    "thisNoteIsPrivate": "Cette note est privée.",
    "createPublicLink": "Créer un lien public",
    "creatingLink": "Création du lien…",
    "revokeLink": "Révoquer le lien",
    "revokingLink": "Révocation…",
    "copyLink": "Copier le lien",
    "copyNoteId": "Copier l'ID de la note",
    "noteIdCopied": "ID de la note copié",
    "exportAs": "Exporter en",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Texte brut",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Échec de l'export",
    "viewHistory": "Voir l'historique",
    "duplicate": "Dupliquer",
    "duplicateFailed": "Impossible de dupliquer la note",
    "select": "Sélectionner",
    "delete": "Supprimer",
    "moveToTrash": "Mettre à la corbeille",
    "archive": "Archiver",
    "unarchive": "Désarchiver",
    "tags": "Étiquettes",
    "addTag": "Ajouter une étiquette",
    "noTagsYet": "Aucune étiquette pour l'instant",
    "addTagFailed": "Impossible d'ajouter l'étiquette",
    "removeTagFailed": "Impossible de retirer l'étiquette"
  },
  "userMenu": {
    "theme": "Thème",
    "typography": "Typographie",
    "language": "Langue",
    "apiKeys": "Clés API",
    "devices": "Appareils",
    "connectedApps": "Apps connectées",
    "help": "Aide",
    "logOut": "Se déconnecter",
    "defaultUserName": "Utilisateur Caliu",
    "editName": "Modifier le nom",
    "nameLabel": "Nom",
    "namePlaceholder": "Votre nom",
    "upgradeToPro": "Passer à Caliu Pro",
    "replayOnboarding": "Revoir l'introduction",
    "logOutTitle": "Se déconnecter ?",
    "logOutBody": "Vos notes restent sur cet appareil et vous pouvez continuer à les lire et à les modifier. Reconnectez-vous pour synchroniser.",
    "logOutPending_one": "{{count}} modification n'est pas encore synchronisée. Elle reste sur cet appareil jusqu'à votre prochaine connexion.",
    "logOutPending_other": "{{count}} modifications ne sont pas encore synchronisées. Elles restent sur cet appareil jusqu'à votre prochaine connexion.",
    "logOutKeep": "Se déconnecter",
    "logOutAndRemove": "Se déconnecter et supprimer les notes"
  },
  "help": {
    "title": "Centre d'aide",
    "searchPlaceholder": "Rechercher des articles d'aide",
    "noResults": "Aucun article ne correspond à votre recherche.",
    "offline": "L'aide n'est pas disponible hors ligne. Elle se chargera à votre prochaine connexion."
  },
  "fonts": {
    "uiFont": "Police de l'interface",
    "body": "Corps",
    "headings": "Titres",
    "code": "Code",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Éditeur",
    "ui": "Interface",
    "reset": "Réinitialiser"
  },
  "themes": {
    "light": "Clair",
    "dark": "Sombre",
    "system": "Système"
  },
  "languages": {
    "systemHint": "Détectée depuis votre appareil",
    "names": {
      "en": "Anglais",
      "es": "Espagnol",
      "ca": "Catalan",
      "fr": "Français",
      "de": "Allemand",
      "it": "Italien",
      "pt": "Portugais",
      "nl": "Néerlandais",
      "ja": "Japonais",
      "zh-CN": "Chinois (simplifié)",
      "ko": "Coréen",
      "zh-TW": "Chinois (traditionnel)",
      "ru": "Russe"
    }
  },
  "bulkActions": {
    "pinSelected": "Épingler la sélection",
    "unpinSelected": "Désépingler la sélection",
    "pin": "Épingler",
    "addTag": "Ajouter une étiquette",
    "filterTags": "Filtrer les étiquettes…",
    "noTagsFound": "Aucune étiquette trouvée",
    "exportSelected": "Exporter la sélection",
    "restoreSelected": "Restaurer la sélection",
    "deletePermanently": "Supprimer définitivement",
    "moveToTrash": "Mettre à la corbeille",
    "archiveSelected": "Archiver la sélection",
    "unarchiveSelected": "Désarchiver la sélection",
    "exportingTitle": "Exportation de vos notes",
    "exportingBody": "Cela peut prendre un moment. Gardez cet onglet ouvert jusqu'à la fin.",
    "exportingProgress": "{{done}} sur {{total}}"
  },
  "commandPalette": {
    "placeholder": "Rechercher notes, étiquettes, commandes…",
    "noResults": "Aucun résultat pour «{{query}}»",
    "currentNote": "Note actuelle",
    "navigation": "Navigation",
    "notes": "Notes",
    "tags": "Étiquettes",
    "newNote": "Nouvelle note",
    "allNotes": "Toutes les notes",
    "todaysNotes": "Notes d'aujourd'hui",
    "todo": "Tâches",
    "pinnedNotes": "Notes épinglées",
    "trash": "Corbeille",
    "importNotes": "Importer des notes",
    "changeTheme": "Changer de thème",
    "keyboardShortcuts": "Raccourcis clavier",
    "pinNote": "Épingler la note",
    "unpinNote": "Désépingler la note",
    "restoreNote": "Restaurer la note",
    "copyShareLink": "Copier le lien de partage",
    "makePrivate": "Rendre privée",
    "toggleFullscreen": "Plein écran",
    "noteInfo": "Infos de la note",
    "moveToTrash": "Mettre à la corbeille",
    "archiveNote": "Archiver la note",
    "unarchiveNote": "Désarchiver la note",
    "archive": "Archivées"
  },
  "noteHistory": {
    "title": "Historique de la note",
    "requiresConnection": "L'historique nécessite une connexion.",
    "reconnect": "Reconnectez-vous à Internet et réessayez.",
    "noHistory": "Aucun historique pour cette note.",
    "windowMerged": "Les modifications dans une fenêtre de 5 minutes sont fusionnées en une seule entrée.",
    "selectVersion": "Sélectionnez une version pour la prévisualiser",
    "encrypted": "Version chiffrée",
    "encryptedHint": "Cette version a été enregistrée avec un chiffrement de bout en bout. Ouvrez la note pour voir le contenu actuel.",
    "restoreVersion": "Restaurer cette version ?",
    "restoreVersionHint": "Cela remplacera le contenu actuel de la note par la version du {{date}}.",
    "current": "Actuelle",
    "created": "Créée",
    "trashed": "Mise à la corbeille",
    "restored": "Restaurée",
    "edited": "Modifiée"
  },
  "apiKeys": {
    "title": "Clés API",
    "empty": "Pas encore de clés API.",
    "emptyHint": "Créez-en une pour commencer à utiliser l'API.",
    "created": "Créée le {{date}}",
    "lastUsed": "Dernière utilisation : {{date}}",
    "revokeKey": "Révoquer la clé",
    "viewApiDocs": "Voir la documentation de l'API",
    "newApiKey": "Nouvelle clé API",
    "apiKeyCreated": "Clé API créée",
    "createApiKey": "Créer une clé API",
    "copyHint": "Copiez cette clé maintenant. Vous ne pourrez plus la voir.",
    "copyToClipboard": "Copier dans le presse-papiers",
    "keyName": "Nom de la clé",
    "keyNamePlaceholder": "ex. : Mon script, Intégration Zapier",
    "createKey": "Créer la clé",
    "revokeKeyTitle": "Révoquer la clé API",
    "revokeKeyHint": "Cela révoquera définitivement cette clé API. Toutes les applications qui l'utilisent perdront l'accès immédiatement.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Apps connectées",
    "empty": "Pas encore d'apps connectées.",
    "emptyHint": "Connectez Claude, ChatGPT ou un autre assistant IA pour utiliser vos notes depuis le chat. La section Caliu avec l'IA, dans Aide, explique comment faire.",
    "connected": "Connectée le {{date}}",
    "lastUsed": "Dernière utilisation : {{date}}",
    "revoke": "Révoquer",
    "revokeTitle": "Révoquer la connexion",
    "revokeHint": "Cela révoquera l'accès de <strong>{{name}}</strong> à votre compte Caliu et supprimera les identifiants utilisés. Il perdra l'accès immédiatement.",
    "thisApp": "cette app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Écriture",
    "metadata": "Métadonnées",
    "words": "Mots",
    "characters": "Caractères",
    "paragraphs": "Paragraphes",
    "readTime": "Temps de lecture",
    "minutes": "{{count}} min",
    "tags": "Étiquettes",
    "outgoingLinks": "Liens sortants",
    "backlinks": "Liens entrants",
    "created": "Créée",
    "modified": "Modifiée",
    "noteStatistics": "Statistiques de la note",
    "identifier": "Identifiant"
  },
  "inspector": {
    "tabInfo": "Infos",
    "tabOutline": "Plan",
    "tabHistory": "Historique",
    "dates": "Dates",
    "noHeadings": "Aucun titre dans cette note",
    "noBacklinks": "Aucune note ne renvoie ici",
    "noOutgoing": "Cette note ne renvoie vers rien",
    "noAttachments": "Aucune pièce jointe dans cette note",
    "historyOffline": "L'historique des versions nécessite une connexion",
    "historyLoadMore": "Charger plus"
  },
  "devices": {
    "title": "Appareils",
    "offline": "Vous êtes hors ligne.",
    "offlineHint": "Connectez-vous à Internet pour voir vos appareils.",
    "noSessions": "Aucune session active trouvée.",
    "thisDevice": "Cet appareil",
    "lastUsed": "Dernière utilisation : {{date}}",
    "created": "Créé : {{date}}",
    "signOutCurrent": "Se déconnecter de cet appareil",
    "signOut": "Se déconnecter",
    "confirmCurrentTitle": "Se déconnecter de cet appareil ?",
    "confirmRevokeTitle": "Révoquer l'appareil ?",
    "confirmCurrentBody": "Vous serez déconnecté de Caliu sur ce navigateur, et les notes seront retirées de cet appareil. Reconnectez-vous quand vous voulez et elles reviendront depuis votre compte.",
    "confirmRevokeBody": "L'appareil sera déconnecté immédiatement. Les modifications non synchronisées y resteront jusqu'à votre prochaine connexion.",
    "revoke": "Révoquer"
  },
  "errorScreen": {
    "title": "Une erreur est survenue",
    "defaultMessage": "Une erreur inattendue est survenue. Essayez de recharger la page."
  },
  "importModal": {
    "title": "Importer des notes",
    "dropToImport": "Déposez pour importer",
    "dropOrClick": "Déposez des fichiers ou cliquez pour parcourir",
    "removeFile": "Retirer le fichier",
    "keepNote": "Pour Google Keep, exportez une archive ZIP via Takeout et envoyez-la directement.",
    "importedCount_one": "<strong>{{count}}</strong> note importée",
    "importedCount_other": "<strong>{{count}}</strong> notes importées",
    "fromSource": " depuis {{source}}",
    "importing": "Importation…",
    "importN": "Importer {{count}} fichiers",
    "importBtn": "Importer"
  },
  "share": {
    "shareNote": "Partager la note",
    "publiclySharedAria": "La note est partagée publiquement",
    "copyLink": "Copier le lien",
    "revokingLink": "Révocation…",
    "revokeLink": "Révoquer le lien",
    "creatingLink": "Création du lien…",
    "createPublicLink": "Créer un lien public",
    "shareThisNotePublicly": "Partager cette note publiquement",
    "thisNoteIsPrivate": "Cette note est privée.",
    "publiclyShared": "Partagée publiquement",
    "privateNote": "Note privée"
  },
  "shortcuts": {
    "searchPlaceholder": "Rechercher des raccourcis…",
    "pressNew": "Appuyez sur le nouveau raccourci…",
    "resetToDefault": "Réinitialiser",
    "noMatches": "Aucun raccourci ne correspond à «&nbsp;<strong>{{query}}</strong>&nbsp;»",
    "navigate": "naviguer",
    "edit": "modifier",
    "closeAction": "fermer",
    "resetAll": "Tout réinitialiser"
  },
  "tagEditor": {
    "icon": "Icône",
    "color": "Couleur",
    "searchIcons": "Rechercher des icônes",
    "noIcons": "Aucune icône ne correspond",
    "categories": {
      "essentials": "Essentiels",
      "work": "Travail et tech",
      "ideas": "Idées et créativité",
      "life": "Personnes et maison",
      "travel": "Voyages et nature",
      "fun": "Cuisine, santé et loisirs"
    }
  },
  "tagActions": {
    "pin": "Épingler l'étiquette",
    "unpin": "Désépingler l'étiquette",
    "rename": "Renommer…",
    "renameTitle": "Renommer l'étiquette",
    "renameConfirm": "Renommer",
    "renameHint": "L'étiquette est mise à jour dans toutes les notes qui l'utilisent, y compris les notes archivées et la corbeille.",
    "renamed": "Étiquette renommée",
    "nameInUse": "Ce nom est déjà utilisé",
    "invalidName": "Les noms d'étiquette ne peuvent contenir que des lettres, des chiffres, des espaces, des tirets et des tirets bas",
    "pinFailed": "Impossible de mettre à jour l'étiquette",
    "renameFailed": "Impossible de renommer l'étiquette",
    "editAppearance": "Modifier l'apparence"
  },
  "auth": {
    "appName": "Caliu",
    "or": "ou",
    "email": "E-mail",
    "emailPlaceholder": "vous@exemple.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "Mot de passe",
    "name": "Nom",
    "namePlaceholder": "Votre nom",
    "confirmPassword": "Confirmer le mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe",
    "signInSubtitle": "Connectez-vous à votre compte",
    "createAccountSubtitle": "Créez votre compte",
    "forgotPassword": "Mot de passe oublié ?",
    "signingIn": "Connexion…",
    "signIn": "Se connecter",
    "noAccount": "Pas de compte ?",
    "signUp": "S'inscrire",
    "haveAccount": "Vous avez déjà un compte ?",
    "creatingAccount": "Création du compte…",
    "createAccount": "Créer un compte",
    "googleSignUpAria": "S'inscrire avec Google",
    "signupClosedTitle": "Les inscriptions sont fermées",
    "signupClosedBody": "Caliu est en bêta privée. Rejoignez la liste d'attente sur caliuapp.com pour un accès anticipé.",
    "joinWaitlist": "Rejoindre la liste d'attente",
    "forgotTitle": "Réinitialiser le mot de passe",
    "forgotSubtitle": "Entrez votre e-mail et nous vous enverrons un lien de réinitialisation.",
    "sendResetLink": "Envoyer le lien de réinitialisation",
    "sending": "Envoi…",
    "checkYourEmail": "Vérifiez votre e-mail",
    "resetLinkSentPrefix": "Si ",
    "resetLinkSentSuffix": " a un compte, nous avons envoyé un lien de réinitialisation. Il expire dans 1 heure.",
    "backToSignIn": "Retour à la connexion",
    "verifySentPrefix": "Nous avons envoyé un lien de vérification à ",
    "verifySentSuffix": ". Cliquez dessus pour activer votre compte.",
    "linkExpires10m": "Le lien expire dans 10 minutes.",
    "resending": "Renvoi…",
    "resendEmail": "Renvoyer l'e-mail",
    "wrongEmail": "Mauvaise adresse e-mail ?",
    "goBack": "Retour",
    "invalidResetLinkTitle": "Lien de réinitialisation invalide",
    "invalidResetLinkBody": "Ce lien est invalide ou a expiré.",
    "requestNewLink": "Demander un nouveau lien",
    "setNewPasswordTitle": "Définir un nouveau mot de passe",
    "setNewPasswordHint": "Choisissez un mot de passe fort.",
    "updatingPassword": "Mise à jour…",
    "updatePassword": "Mettre à jour le mot de passe",
    "localNotesTitle": "Vous avez des notes sur cet appareil",
    "localNotesBody_one": "Vous avez écrit {{count}} note ici avant de vous connecter. Que faut-il en faire ?",
    "localNotesBody_other": "Vous avez écrit {{count}} notes ici avant de vous connecter. Que faut-il en faire ?",
    "localNotesDelete": "Les supprimer",
    "localNotesMerge": "Les ajouter à mon compte",
    "backToMyNotes": "Retour à mes notes",
    "errorGoogleAuthFailed": "La connexion avec Google a échoué. Réessayez.",
    "errorInvalidToken": "Lien de vérification non valide. Inscrivez-vous à nouveau.",
    "errorEmailTaken": "Cet e-mail est déjà utilisé. Connectez-vous.",
    "signInInstead": "Se connecter à ce compte",
    "errorIdentityTaken": "Cette identité appartient déjà à un autre compte Caliu. Connectez-vous à ce compte.",
    "parkedNotesTitle": "Notes d'un autre compte",
    "parkedNotesBody_one": "Connectez-vous à {{email}} pour conserver ses notes sur cet appareil. Un autre compte effacera la seule note présente ici, y compris ce qui a été écrit depuis.",
    "parkedNotesBody_other": "Connectez-vous à {{email}} pour conserver ses notes sur cet appareil. Un autre compte effacera les {{count}} notes présentes ici, y compris ce qui a été écrit depuis.",
    "parkedNotesBodyNoEmail_one": "Connectez-vous au compte dont vous vous êtes déconnecté pour conserver ses notes sur cet appareil. Un autre compte effacera la seule note présente ici, y compris ce qui a été écrit depuis.",
    "parkedNotesBodyNoEmail_other": "Connectez-vous au compte dont vous vous êtes déconnecté pour conserver ses notes sur cet appareil. Un autre compte effacera les {{count}} notes présentes ici, y compris ce qui a été écrit depuis.",
    "parkedNotesContinue": "Continuer"
  },
  "connectors": {
    "wantsAccess": "demande l'accès à Caliu",
    "couldntLoad": "Impossible de charger cette demande",
    "authorize": "Autoriser",
    "keepHappeningHint": "Si cela persiste, supprimez le connecteur de votre client MCP et ajoutez-le à nouveau.",
    "backToCaliu": "Retour à Caliu",
    "askingPermissionPrefix": "demande l'autorisation de lire et modifier vos notes et étiquettes via le serveur MCP de Caliu.",
    "signedInAs": "Connecté en tant que {{name}}.",
    "permissions": "Autorisations",
    "deny": "Refuser",
    "allow": "Autoriser"
  },
  "editorTypography": {
    "fontSize": "Taille de la police",
    "lineHeight": "Hauteur de ligne",
    "paragraphSpacing": "Espacement des paragraphes"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Maj"
  },
  "floatingMenu": {
    "undo": "Annuler",
    "redo": "Rétablir",
    "taskList": "Liste de tâches",
    "bulletList": "Liste à puces",
    "orderedList": "Liste numérotée",
    "blockQuote": "Citation",
    "separator": "Séparateur",
    "insertTag": "Insérer une étiquette",
    "highlight": "Surligner",
    "math": "Formule",
    "removeHighlight": "Retirer le surlignage",
    "inlineCode": "Code inline",
    "codeBlock": "Bloc de code",
    "insertTable": "Insérer un tableau",
    "insertImage": "Insérer une image",
    "hideStyleBar": "Masquer la barre de style",
    "attachFile": "Joindre un fichier",
    "photoLibrary": "Photothèque",
    "camera": "Appareil photo",
    "fromFile": "Depuis un fichier"
  },
  "imageDialog": {
    "title": "Insérer une image",
    "tabUpload": "Fichier",
    "tabUrl": "URL",
    "urlLabel": "URL de l'image",
    "urlPlaceholder": "https://exemple.com/image.jpg",
    "altLabel": "Texte alternatif",
    "altPlaceholder": "Décrire l'image…",
    "previewAlt": "aperçu",
    "changeImage": "Changer d'image",
    "dropToInsert": "Déposer pour insérer",
    "dropOrClick": "Déposez une image ou cliquez pour parcourir",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Insérer l'image"
  },
  "linkDialog": {
    "editTitle": "Modifier le lien",
    "insertTitle": "Insérer un lien",
    "textLabel": "Texte",
    "textPlaceholder": "Texte du lien",
    "urlPlaceholder": "https://exemple.com",
    "removeLink": "Supprimer le lien",
    "openLink": "Ouvrir le lien",
    "editLink": "Modifier le lien"
  },
  "noteEditor": {
    "notFound": "Note introuvable.",
    "inTrashBanner": "Cette note est dans la corbeille. Restaurez-la pour la modifier.",
    "restore": "Restaurer",
    "noContent": "Cette note n'a aucun contenu."
  },
  "noteHeader": {
    "noteInfo": "Infos sur la note"
  },
  "table": {
    "deleteRow": "Supprimer la ligne",
    "deleteTable": "Supprimer le tableau",
    "addRow": "Ajouter une ligne",
    "addRowAbove": "Ajouter une ligne au-dessus",
    "addColumn": "Ajouter une colonne",
    "addColumnBefore": "Ajouter une colonne avant",
    "moveRowUp": "Déplacer la ligne vers le haut",
    "moveRowDown": "Déplacer la ligne vers le bas",
    "moveColumnLeft": "Déplacer la colonne à gauche",
    "moveColumnRight": "Déplacer la colonne à droite",
    "deleteColumn": "Supprimer la colonne",
    "actions": "Actions du tableau"
  },
  "syncIndicator": {
    "synced": "Synchronisé",
    "pending_one": "{{count}} synchronisation en attente",
    "pending_other": "{{count}} synchronisations en attente",
    "offline": "Hors ligne",
    "offlinePending_one": "Hors ligne · {{count}} en attente",
    "offlinePending_other": "Hors ligne · {{count}} en attente",
    "syncing": "Synchronisation...",
    "conflict_one": "{{count}} conflit",
    "conflict_other": "{{count}} conflits",
    "error": "Erreur de synchronisation",
    "syncedTooltip": "Toutes les modifications enregistrées",
    "pendingTooltip_one": "{{count}} modification en attente de synchronisation",
    "pendingTooltip_other": "{{count}} modifications en attente de synchronisation",
    "offlineTooltip": "Hors ligne : les modifications seront synchronisées à la reconnexion",
    "offlinePendingTooltip_one": "Hors ligne : {{count}} modification sera synchronisée à la reconnexion",
    "offlinePendingTooltip_other": "Hors ligne : {{count}} modifications seront synchronisées à la reconnexion",
    "syncingTooltip": "Synchronisation...",
    "syncingPendingTooltip_one": "Synchronisation de {{count}} modification en attente...",
    "syncingPendingTooltip_other": "Synchronisation de {{count}} modifications en attente...",
    "conflictTooltip_one": "{{count}} note a des modifications en conflit. Cliquez pour résoudre.",
    "conflictTooltip_other": "{{count}} notes ont des modifications en conflit. Cliquez pour résoudre.",
    "errorTooltip": "Échec de la synchronisation. Nouvelle tentative automatique.",
    "conflictsTitle": "Résoudre les conflits",
    "local": "Sur cet appareil",
    "localTooltip": "Sur cet appareil uniquement. Connectez-vous pour synchroniser."
  },
  "image": {
    "download": "Télécharger l'image",
    "replace": "Remplacer l'image",
    "remove": "Retirer l'image"
  },
  "sharePage": {
    "goToCaliu": "Aller à Caliu",
    "noteNotFoundTitle": "Note introuvable",
    "somethingWentWrong": "Une erreur est survenue",
    "lastUpdated": "Dernière mise à jour : {{date}}",
    "tagline": "Une appli de notes pour les penseurs",
    "subtagline": "Écrivez en markdown. Synchronisez partout. Pensez clairement.",
    "startWriting": "Commencer à écrire",
    "signIn": "Se connecter",
    "openInCaliu": "Ouvrir dans Caliu",
    "adding": "Ajout…",
    "addToSharedList": "Ajouter à ma liste partagée",
    "notFoundSubtitle": "Ce lien partagé a peut-être expiré ou été révoqué.",
    "errorSubtitle": "Impossible de charger cette note. Veuillez réessayer."
  },
  "sharedView": {
    "loading": "Chargement de la note partagée…",
    "sharedWithYou": "Partagée avec vous",
    "viewRaw": "Afficher le Markdown brut",
    "viewRendered": "Afficher la note mise en forme",
    "copyMarkdown": "Copier le Markdown",
    "markdownCopied": "Markdown copié",
    "copyFailed": "Échec de la copie",
    "notLoadedYet": "Cette note n'est pas encore chargée",
    "linkCopied": "Lien copié",
    "actions": "Actions de la note"
  },
  "sharedWithMe": {
    "title": "Partagées avec moi",
    "removeFromList": "Retirer de la liste",
    "empty": "Pas encore de notes partagées",
    "emptyHint": "Ouvrez un lien partagé Caliu d'un ami pour l'ajouter ici. Les notes partagées se synchronisent sur tous vos appareils."
  },
  "trashView": {
    "empty": "La corbeille est vide",
    "emptyHint": "Les notes supprimées apparaîtront ici",
    "retention": "Les notes dans la corbeille sont supprimées définitivement après 30 jours",
    "trash": "Corbeille"
  },
  "fileAttachment": {
    "download": "Télécharger le fichier",
    "remove": "Supprimer le fichier"
  },
  "archiveView": {
    "archive": "Archivées",
    "empty": "Les archives sont vides",
    "emptyHint": "Les notes archivées apparaîtront ici",
    "archivedOn": "Archivée le {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, sans aucune limite.",
    "features": [
      "Notes illimitées",
      "Historique des versions de notes",
      "Export PDF, HTML, RTF, ePub + en lot",
      "Tous les thèmes, polices et icônes d'app",
      "Soutient le développement de Caliu"
    ],
    "perMonth": "{{price}} par mois",
    "perWeek": "{{price}} par semaine",
    "oneTime": "{{price}} en une fois",
    "perYear": "{{price}} par an",
    "or": "ou",
    "signInToSubscribe": "Connectez-vous pour vous abonner",
    "accountRequired": "Caliu Pro est lié à votre compte et se débloque sur tous vos appareils.",
    "plansUnavailable": "Impossible de charger les formules. Vérifiez votre connexion et réessayez.",
    "yearly": "Annuel",
    "monthly": "Mensuel",
    "continue": "Continuer",
    "bestValue": "Meilleure offre",
    "autoRenew": "{{amount}}. Renouvellement automatique jusqu'à résiliation. Annulez à tout moment.",
    "freeTrial": "Gratuit pendant {{count}} jours",
    "billedSubtitle": "Gratuit pendant {{count}} jours, puis {{amount}}. Annulez à tout moment.",
    "startTrial": "Commencer l'essai gratuit",
    "upgradeSubtitle": "Historique des versions, tous les thèmes et polices, export et bien plus.",
    "upgradeNow": "Mettre à niveau",
    "thanks": "Merci de soutenir Caliu !",
    "renewsOn": "Renouvellement le {{date}}",
    "endsOn": "Se termine le {{date}}",
    "lifetime": "Accès à vie",
    "lifetimePlan": "À vie",
    "oneTimeNoRenewal": "Paiement unique",
    "launchPrice": "Prix de lancement. Il passera ensuite à {{price}}.",
    "buy": "Acheter",
    "oneTimeDisclosure": "{{amount}}. Paiement unique, sans renouvellement.",
    "thanksMessage": "Votre soutien garde Caliu indépendant et privé.",
    "manageSubscription": "Gérer l'abonnement",
    "contactUs": "Des questions ? Contactez-nous",
    "grandfatheredNote": "En tant que soutien de la première heure, Caliu Pro est à vous à vie. Rien à renouveler.",
    "webFootnote": "L'export PDF n'est pas encore disponible sur le web.",
    "active": "Actif"
  },
  "find": {
    "placeholder": "Rechercher dans la note",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Aucun résultat",
    "next": "Occurrence suivante",
    "previous": "Occurrence précédente",
    "close": "Fermer"
  },
  "conflicts": {
    "description": "Cette note a été modifiée sur un autre appareil. Gardez une version.",
    "yours": "Votre version",
    "theirs": "Leur version",
    "step": "{{current}} sur {{total}}",
    "keepYours": "Garder la vôtre",
    "keepTheirs": "Garder la leur",
    "serverError": "Impossible de charger l'autre version.",
    "done": "Tous les conflits sont résolus.",
    "previous": "Conflit précédent",
    "next": "Conflit suivant",
    "copyOf": "Copie de {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Bienvenue dans Caliu",
    "welcomeSubtitle": "Un endroit tranquille pour laisser vivre et respirer vos pensées.",
    "getStarted": "Commencer",
    "magicTitle": "Regardez vos mots prendre forme",
    "magicSubtitle": "Vous écrivez du texte brut. Caliu le transforme en structure : tâches, surlignages et étiquettes qui se rangent toutes seules.",
    "magicLearnMore": "Apprenez les bases du Markdown",
    "replay": "Rejouer",
    "demoTitle": "Un été au bord de la mer",
    "demoBody": "Prévoir une **semaine tranquille** dans une petite ville.",
    "demoTask": "Réserver la petite maison",
    "demoHighlight": "Nager ==avant== le petit-déjeuner",
    "demoTags": "#été #projets",
    "intentTitle": "Qu'allez-vous apporter ici ?",
    "intentSubtitle": "Choisissez-en quelques-uns. Votre première note et vos étiquettes vous attendront, déjà à vous.",
    "themeTitle": "Choisissez votre lumière",
    "themeSubtitle": "Des thèmes pour accompagner l'ambiance de votre écriture.",
    "proTitle": "Commencez avec tout",
    "proSubtitle": "Commencez avec tout dès le premier jour. Essayez-le gratuitement, gardez-le seulement s'il mérite sa place.",
    "proTrust": "Pas de publicité. Pas de pièges. Annulez à tout moment.",
    "tryProFree": "Essayer Pro gratuitement",
    "continueFree": "Continuer avec la formule gratuite",
    "allSetTitle": "Vous êtes prêt",
    "allSetSubtitle": "Bienvenue dans Caliu. À vous de jouer.",
    "startWriting": "Commencer à écrire",
    "firstNoteTitle": "Là où tout commence",
    "firstNoteBody": "Voici ma première note. Elle vit sur cet appareil, fonctionne hors ligne et me suit partout.",
    "firstNoteTask": "Noter une pensée qui vaut la peine d'être gardée",
    "next": "Suivant",
    "skip": "Passer",
    "back": "Retour",
    "intents": {
      "journal": "Journal intime",
      "ideas": "Idées",
      "work": "Travail",
      "study": "Études",
      "reading": "Lecture",
      "plans": "Projets"
    },
    "signInCta": "Se connecter ou s'inscrire",
    "continueWithoutAccount": "Continuer sans compte",
    "backupTitle": "Où vivent vos notes",
    "backupSubtitle": "Elles commencent sur cet appareil. Avec un compte, elles se synchronisent et une copie sûre arrive sur tous vos appareils.",
    "syncOffTitle": "La synchronisation est désactivée",
    "syncOffBody": "Connectez-vous pour synchroniser vos notes sur tous vos appareils.",
    "backupSignedIn": "Vos notes sont synchronisées en toute sécurité pendant que vous écrivez.",
    "backupStageDevice": "Cet appareil",
    "backupStageSafe": "Synchronisées",
    "backupStageEverywhere": "Tous vos appareils",
    "freeNotes": "{{limit}} notes gratuites, sans compte, pour toujours. Pro les rend illimitées."
  },
  "backup": {
    "evictionNotice": "Pour l'instant, les notes vivent uniquement dans ce navigateur. Les navigateurs peuvent effacer les données du site quand l'espace manque.",
    "dismiss": "Ignorer",
    "signIn": "Se connecter"
  },
  "gate": {
    "share": "Connectez-vous pour partager des notes.",
    "history": "Connectez-vous pour conserver l'historique des versions.",
    "import": "Connectez-vous pour importer des notes."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "Source LaTeX"
  },
  "noteLimit": {
    "banner": "{{count}} notes sur {{limit}}",
    "paywallTitle": "Vous avez atteint les {{limit}} notes gratuites",
    "paywallBody": "L'édition, la recherche et la synchronisation continuent de fonctionner. Mettez une note à la corbeille pour libérer une place, ou passez en illimité avec Caliu Pro : mensuel, annuel ou avec un achat unique à vie.",
    "importCapped": "Seuls {{count}} fichiers sur {{total}} ont été importés : le plan gratuit autorise {{limit}} notes."
  },
  "appUpdate": {
    "available": "Une nouvelle version de Caliu est disponible."
  },
  "settings": {
    "title": "Réglages",
    "account": "Compte",
    "writing": "Écriture",
    "keyboardShortcuts": "Raccourcis clavier",
    "editor": "Éditeur",
    "yourNotes": "Vos notes",
    "about": "À propos",
    "noAccount": "Pas de compte",
    "sendFeedback": "Envoyer un commentaire",
    "signInOrCreate": "Se connecter ou s'inscrire",
    "notesComeWithYou": "Les notes de cet appareil vous accompagnent.",
    "notSyncing": "Non synchronisé",
    "signInToSync": "Connectez-vous pour synchroniser vos notes.",
    "sync": "Synchronisation",
    "security": "Sécurité",
    "communications": "Communications",
    "newsletter": "Newsletter de Caliu",
    "newsletterFooter": "Un court e-mail de temps en temps sur les nouvelles versions et ce qui arrive dans Caliu.",
    "newsletterError": "Impossible de mettre à jour la newsletter. Réessayez.",
    "appearance": "Apparence",
    "themes": "Thèmes",
    "sizing": "Taille",
    "systemDefault": "Par défaut du système",
    "separateThemes": "Thèmes distincts pour clair et sombre",
    "maxWidth": "Largeur maximale",
    "maxWidthHint": "Centre le texte dans une colonne lisible sur les écrans larges",
    "markdownReturn": "Retour façon Markdown",
    "markdownReturnHint": "Retour insère un saut de ligne. Appuyez deux fois sur Retour pour un nouveau paragraphe",
    "newNoteStart": "Les nouvelles notes commencent par",
    "newNoteStartH1": "Titre 1",
    "newNoteStartH2": "Titre 2",
    "newNoteStartH3": "Titre 3",
    "newNoteStartH4": "Titre 4",
    "newNoteStartDate": "Date",
    "newNoteStartDateIso": "Date (ISO 8601)",
    "newNoteStartDateTime": "Date et heure",
    "newNoteStartDateTimeIso": "Date et heure (ISO 8601)",
    "newNoteStartEmpty": "Vide",
    "newNoteStartHint": "S'applique aux notes que vous créez dans l'app.",
    "collapsibleSections": "Sections repliables",
    "collapsibleSectionsHint": "Permet de replier un titre et son contenu derrière un chevron",
    "experimental": "Expérimental",
    "general": "Général"
  },
  "toolbar": {
    "toggleSidebar": "Afficher/Masquer la barre latérale",
    "toggleInspector": "Afficher/masquer l'inspecteur",
    "searchNotes": "Rechercher des notes",
    "newNote": "Nouvelle note",
    "findInNote": "Rechercher dans la note",
    "showToolbar": "Afficher la barre d'outils",
    "hideToolbar": "Masquer la barre d'outils",
    "moreNoteActions": "Plus d'actions sur la note",
    "undo": "Annuler",
    "redo": "Rétablir",
    "zenMode": "Mode Zen",
    "sourceMode": "Mode source",
    "richEditor": "Éditeur enrichi",
    "sortBy": "Trier par",
    "bold": "Gras",
    "italic": "Italique",
    "heading": "Titre",
    "list": "Liste",
    "link": "Lien",
    "insert": "Insérer",
    "more": "Plus",
    "strikethrough": "Barré",
    "table": "Tableau",
    "horizontalRule": "Filet horizontal",
    "codeBlock": "Bloc de code",
    "inlineCode": "Code en ligne",
    "blockQuote": "Citation",
    "math": "Formule",
    "highlight": "Surlignage",
    "bulletList": "Liste à puces",
    "orderedList": "Liste numérotée",
    "photoLibrary": "Photothèque",
    "camera": "Appareil photo",
    "files": "Fichiers",
    "yellow": "Jaune",
    "green": "Vert",
    "blue": "Bleu",
    "pink": "Rose",
    "purple": "Violet",
    "heading1": "Titre 1",
    "heading2": "Titre 2",
    "heading3": "Titre 3",
    "heading4": "Titre 4",
    "heading5": "Titre 5",
    "heading6": "Titre 6",
    "removeHighlight": "Supprimer le surlignage"
  },
  "whatsNew": {
    "title": "Nouveautés",
    "tagIconsTitle": "Des icônes dessinées pour Caliu",
    "tagIconsBody": "Toutes les icônes de l'app sont nouvelles et conçues pour Caliu. Donnez à chaque étiquette sa propre icône et recherchez-les dans votre langue.",
    "newNoteStartTitle": "Commencez vos notes à votre façon",
    "newNoteStartBody": "Une nouvelle note peut s'ouvrir sur un titre, la date du jour, la date et l'heure, ou une page vide. Choisissez-le dans Réglages, section Éditeur.",
    "typographyTitle": "Une typographie au point près",
    "typographyBody": "Choisissez la taille exacte du texte, l'interligne et l'espacement des paragraphes de vos notes, dans Réglages, section Typographie.",
    "typographySample": "Chaque note suit la taille, l'interligne et l'espacement que vous choisissez, au point près.",
    "sampleMorningPages": "Pages du matin",
    "newsletterTitle": "Voici la newsletter de Caliu",
    "newsletterBody": "Désormais, un court e-mail vous présente les nouveautés de chaque version, dans votre langue. Activez-la si vous le souhaitez. Vous pouvez changer d'avis à tout moment dans les Réglages."
  },
  "sharing": {
    "inviteByEmail": "Inviter par e-mail",
    "invite": "Inviter",
    "roleOwner": "Propriétaire",
    "roleEditor": "Peut modifier",
    "roleViewer": "Peut consulter",
    "generalAccess": "Accès général",
    "shareWithLink": "Partager avec un lien",
    "accessRestricted": "Seulement les personnes invitées",
    "accessView": "Toute personne disposant du lien peut consulter",
    "accessEdit": "Toute personne disposant du lien peut modifier",
    "remove": "Retirer",
    "leave": "Quitter",
    "leaveNote": "Quitter la note",
    "leaveConfirmTitle": "Quitter cette note ?",
    "leaveConfirmBody": "Elle disparaîtra de vos listes sur tous vos appareils. Son propriétaire pourra vous inviter à nouveau.",
    "leaveSelectedTitle": "Quitter les notes partagées ?",
    "leaveSelectedBody_one": "Vous quitterez {{count}} note partagée avec vous. Vos propres notes iront à la corbeille.",
    "leaveSelectedBody_other": "Vous quitterez {{count}} notes partagées avec vous. Vos propres notes iront à la corbeille.",
    "sharedBy": "Partagée par {{name}}",
    "sharedList": "Partagées",
    "viewOnly": "Lecture seule",
    "accessNowEditor": "Vous pouvez maintenant modifier cette note.",
    "accessNowViewer": "Vous pouvez désormais seulement consulter cette note.",
    "accessRemoved": "Vous n'avez plus accès à cette note.",
    "unsentSavedAsCopy": "Vos modifications non envoyées ont été enregistrées dans une copie.",
    "privateNote": "Note privée",
    "memberLimit": "Une note peut être partagée avec 50 personnes au maximum.",
    "rateLimit": "Trop d'invitations. Réessayez plus tard.",
    "inviteFailed": "Impossible d'envoyer les invitations. Réessayez.",
    "invalidEmail": "Saisissez une adresse e-mail valide.",
    "onlineOnly": "Connectez-vous à Internet pour gérer le partage.",
    "you": "Vous",
    "ownerOnly": "Seul le propriétaire peut modifier qui y a accès.",
    "unavailable": "Le partage est indisponible pour le moment. Réessayez plus tard.",
    "updateFailed": "Impossible de mettre à jour le partage. Réessayez.",
    "inviteInvalid": "Cette invitation n'est plus valide.",
    "copyLink": "Copier le lien",
    "invited": "Invité",
    "copied": "Copié",
    "accessRestrictedHint": "Seules les personnes que vous invitez peuvent l'ouvrir.",
    "onlyYouHint": "Vous seul pouvez l'ouvrir.",
    "accessViewHint": "Toute personne disposant du lien peut la lire, sans compte.",
    "accessEditHint": "Toute personne disposant du lien peut la modifier.",
    "roleBelowLink": "Toute personne disposant du lien peut modifier, donc les personnes que vous invitez peuvent aussi modifier.",
    "inviteAs": "Inviter en tant que",
    "revokeInvite": "Révoquer l'invitation",
    "statusPeople_one": "{{count}} personne",
    "statusPeople_other": "{{count}} personnes",
    "publicLink": "Lien public",
    "statusFrom": "De {{name}}",
    "removeConfirmTitle": "Retirer {{name}} ?",
    "removeConfirmBody": "Cette personne n'aura plus accès à cette note.",
    "revokeConfirmTitle": "Révoquer l'invitation envoyée à {{name}} ?",
    "revokeConfirmBody": "Le lien d'invitation ne fonctionnera plus.",
    "peopleWithAccess": "Personnes ayant accès",
    "addPeoplePlaceholder": "Ajouter des personnes par e-mail",
    "invitePro": "Inviter des personnes fait partie de Caliu Pro.",
    "inviteKeepsAccess": "Les personnes invitées gardent l'accès si vous désactivez le lien.",
    "youSuffix": "(vous)"
  },
  "noAccess": {
    "title": "Vous n'avez pas accès à cette note",
    "linkBody": "Son propriétaire ne l'a pas partagée avec vous. Demandez-lui de vous inviter ou d'activer son lien.",
    "signedOutBody": "Connectez-vous avec le compte avec lequel elle a été partagée.",
    "inviteTitle": "Cette invitation n'est plus valide",
    "inviteBody": "Demandez-en une nouvelle à la personne qui vous a invité.",
    "removedTitle": "Vous n'avez plus accès à cette note",
    "removedBody": "Son propriétaire vous a retiré.",
    "removedCopyBody": "Son propriétaire vous a retiré. Vos modifications non envoyées ont été conservées comme copie dans vos notes.",
    "backToNotes": "Retour aux notes",
    "signIn": "Se connecter"
  }
}
